"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var LocaleService = /*#__PURE__*/function () {
  function LocaleService(_ref) {
    var i18n = _ref.i18n;
    _classCallCheck(this, LocaleService);
    this.i18n = void 0;
    this.i18n = i18n;
    this.localeString = this.localeString.bind(this);
    this.formatPrice = this.formatPrice.bind(this);
  }
  _createClass(LocaleService, [{
    key: "localeString",
    value: function localeString(key, options) {
      if (!this.i18n) {
        return key;
      }
      var translation = this.i18n(key, options);
      return translation || key;
    }

    /**
     * Currency specific parsing
     * @param price {string}
     * @param currency {string}
     * @returns {string}
     */
  }, {
    key: "parsePrice",
    value: function parsePrice(price, currency) {
      switch (currency) {
        case 'EUR':
          return price.replace(/\s/, '');
        default:
          return price;
      }
    }
  }, {
    key: "formatPrice",
    value: function formatPrice(amount) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var locale = this.localeString('locale');
      var currency = this.localeString('currency');
      var _options$fraction = options.fraction,
        fraction = _options$fraction === void 0 ? true : _options$fraction;
      var formatOptions = {
        style: 'currency',
        currency: currency
      };
      if (!fraction) {
        formatOptions.minimumFractionDigits = 0;
        formatOptions.maximumFractionDigits = 0;
      }
      var formatter = new Intl.NumberFormat(locale, formatOptions);
      var formattedPrice = formatter.format(amount);
      return this.parsePrice(formattedPrice, currency);
    }
  }]);
  return LocaleService;
}();
var _default = LocaleService;
exports.default = _default;